import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const isAddingMatchingAllowed = (request: selectors.types.NetSuiteExpandedRequest) =>
    request.integrationCode === domain.IntegrationCode.NetSuiteBill &&
    !request.details.internalId &&
    [domain.RequestStatusV2.OnApproval, domain.RequestStatusV2.OnReview, domain.RequestStatusV2.OnHold].includes(
        request.statusV2
    );
